<template>
  <a-modal
      :title="title"
      centered
      :closable="closable"
      :footer="null"
      :maskClosable="false"
      :visible="visible"
      @cancel="closeEdit()"
      :width="width"
  >
    <slot></slot>
  </a-modal>
</template>

<script>
export default {
  name: 'FormModel',
  props: {
    title: {
      default: '详情'
    },
    closable: {
      default: true
    },
    width: {
      default: 1200
    },
    visible: {
      default: false
    }
  },
  methods: {
    closeEdit() {
      // console.log(this.$route.params);
      this.$parent.closeEdit();
    }
  }
}
</script>

<style lang="less" scoped>

</style>
